// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".servicer-login-page .search-box .el-input{width:200px;margin-right:10px}", ""]);
// Exports
module.exports = exports;
